import { PerformanceMeasureServiceImpl } from "./performance-measure";
import { MeasurePerformance } from "./performance-measure-decorator";
import app from "../../sdAppModule";

// todo: check to make sure both performanceMeasure and scenarioMeasure are used.
app
  .constant("measurePerformanceDecorator", MeasurePerformance)
  .service("performanceMeasure", PerformanceMeasureServiceImpl)
  .service("scenarioMeasure", PerformanceMeasureServiceImpl);
